import AliceCarousel from 'react-alice-carousel'
import 'react-alice-carousel/lib/alice-carousel.css'

type CarouselProps = {
    children: React.ReactNode
    responsiveSetting: any
    autoPlay?: boolean
    autoPlayInterval?: number
    animationDuration?: number
    mouseTracking?: boolean
    disableButtonsControls?: boolean
    disableDotsControls?: boolean
}

const responsiveDefault = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 3 },
}

const CarouselControl = (props: CarouselProps) => {
    const {
        children,
        responsiveSetting,
        autoPlay = false,
        animationDuration,
        mouseTracking = true,
        disableButtonsControls = false,
        disableDotsControls = false,
        autoPlayInterval = 1500,
    } = props

    return (
        <AliceCarousel
            responsive={responsiveSetting}
            autoPlay={autoPlay}
            animationDuration={animationDuration}
            mouseTracking={mouseTracking}
            disableButtonsControls={disableButtonsControls}
            disableDotsControls={disableDotsControls}
            // controlsStrategy="alternate"
            autoPlayInterval={autoPlayInterval}
            // activeIndex={1 - 1}
            onSlideChange={(event: any) => {
                // console.log('slide', event)
            }}
        >
            {children}
        </AliceCarousel>
    )
}

export default CarouselControl
